/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SubscriptionTier {
    NONE = 'none',
    STARTER = 'starter',
    BASIC = 'basic',
    PRO = 'pro',
}
